import { render, staticRenderFns } from "./setRelet.vue?vue&type=template&id=36280ee5&scoped=true&"
import script from "./setRelet.vue?vue&type=script&lang=js&"
export * from "./setRelet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36280ee5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36280ee5')) {
      api.createRecord('36280ee5', component.options)
    } else {
      api.reload('36280ee5', component.options)
    }
    module.hot.accept("./setRelet.vue?vue&type=template&id=36280ee5&scoped=true&", function () {
      api.rerender('36280ee5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/dialogs/setRelet.vue"
export default component.exports